module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_10_D_2.48c77419.mp3";